module.exports = "<div ng-transclude>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpComponentSection/adpComponentSection.html
// module id = 471
// module chunks = 0